import React from "react";

import { DateTimeField, Form, SelectField, TimezoneField } from "@culturehq/components";

import { t, Trans } from "app/utils";

const schedulePostTypes = [
  { value: "yes", label: t("Yes") },
  { value: "no", label: t("No") }
];

const ScheduleForLater = ({
  handleOffsetChange,
  handleScheduleAtChange,
  onChooseSchedulePostChanged,
  schedulePostType,
  scheduleAt,
  timezoneOffset
}) => (
  <>
    <SelectField
      options={schedulePostTypes}
      onChange={onChooseSchedulePostChanged}
      required
      value={schedulePostType}
    >
      <h4 className="FieldLabel"><Trans>Do you want to schedule this post for later?</Trans></h4>
    </SelectField>
    {schedulePostType === "yes" && (
      <div className="row">
        <div className="col-sm-6">
          <DateTimeField
            ariaLabel={t("Schedule the post for later")}
            name="scheduleAt"
            offset={timezoneOffset}
            value={scheduleAt}
            onChange={handleScheduleAtChange}
            required
          >
            <Trans>Schedule for</Trans>
          </DateTimeField>
        </div>
        <div className="col-sm-6">
          <Form initialValues={{ timezone: Intl.DateTimeFormat().resolvedOptions().timeZone }}>
            <TimezoneField
              name="timezone"
              onOffsetChange={handleOffsetChange}
            >
              <Trans>Event Time Zone</Trans>
            </TimezoneField>
          </Form>
        </div>
      </div>
    )}
  </>
);

export default ScheduleForLater;
